import type { FormInputValues } from "@/form";

export function sendSynchronousPostRequest(data: FormInputValues) {
    sendSynchronousRequest({
        method: 'post',
        data: data
    });
}

export interface SynchronousRequest {
    method?: string;
    action?: string;
    target?: '_blank';
    data?: FormInputValues;
}

/** 
 * Useful for sending a synchronous request for a file. 
 * This function is currently implemented through a hidden form submission. 
 * Warning: if the method is get, any url params on the action url will be ignored. 
 **/
export function sendSynchronousRequest({ method, action, target, data = {} }: SynchronousRequest) {
    let formEl = document.createElement('form');
    formEl.name = 'synchronousRequest'
    formEl.method = method;
    formEl.action = action || formEl.action;
    formEl.target = target || formEl.target;
    formEl.style.display = 'none';

    for (let name in data) {
        let hiddenEl = document.createElement('input');
        hiddenEl.type = 'hidden';
        hiddenEl.name = name;
        hiddenEl.value = data[name];
        formEl.appendChild(hiddenEl);
    }

    document.body.appendChild(formEl);
    formEl.submit();
    formEl.remove();
}
